module.exports = {"id":"216388","name":"Allan Saint-Maximin","rating":"77","photo":"./data/images/photos/3/216388.png","club":{"name":"OGC Nice","logo":"./data/images/clubs/OGCNice.png"},"positions":["AD","AG","MG","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AllanSaint-Maximin0.json
// module id = 299
// module chunks = 0